<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/75/title-bg.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/70/title-1.png" alt="" />
          <div class="content">
            <div class="font" style="marginBottom: 0.1rem">
              （一）税收和相关经济数据统计关系在锦江区的企事业单位、社会组织以及在锦江区创新创业的各类人才。
            </div>
          </div>
          <div class="content">
            <div class="font">
              （二）申报单位或人才近三年未发生重大安全生产及环境保护事故、重大违法行为，未被纳入失信被执行名单。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/70/title-2.png" alt="" />
          <div class="content">
            符合锦江区急需紧缺人才和高端人才目录，年度工资薪金达100万元以上的人才。
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/70/title-3.png" alt="" />
          <div class="content">
           结合个人社会贡献，参照个人年度区级实际经济贡献的100%给予补贴。单个企业每年度累计不超过10人。
          </div>
        </div>
        <div class="sbcl">
          <img class="top" src="./../assets/imgs/70/title-4.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="item">
                <div class="dot">1</div>
                《锦江区存量中高端产业人才专项补贴申请表》；
              </div>
              <div class="item">
                <div class="dot">2</div>
                申请人所在单位统一社会信用代码复印件；
              </div>
              <div class="item">
                <div class="dot">3</div>
                申请人所在单位纳税证明；
              </div>
              <div class="item">
                <div class="dot">4</div>
                申请人身份证（护照）复印件；
              </div>
              <div class="item">
                <div class="dot">5</div>
                申请人锦江区急需紧缺人才和高端人才认定证明（锦绣锦江电子卡截图）；
              </div>
              <div class="item">
                <div class="dot">6</div>
                申请人劳动合同复印件（公司任职文件）；
              </div>
              <div class="item">
                <div class="dot">7</div>
                申请人年度社保缴纳证明；
              </div>
              <div class="item">
                <div class="dot">8</div>
                申请人年度个税缴纳明细；
              </div>
              <div class="item">
                <div class="dot">9</div>
                诚信申报承诺书。
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img class="top" src="./../assets/imgs/73/title-5.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-86624369">028-86624369</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区委组织部（区委人才办）
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../assets/imgs/70/code.png" />
          <img class="text" src="../assets/imgs/70/text.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }
  .technological-process {
    transform: translateY(-2.1rem);
    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;
        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }
    .sbcl {
      position: relative;
      margin-top: 0.22rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.95rem auto 0;
        padding: 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.15rem 0.23rem 0.3rem;
          margin-top: 0.5rem;
          position: relative;
          .title {
            font-size: 0.3rem;
            font-weight: bold;
            color: #333333;
          }
          .item {
            margin-top: 0.3rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            line-height: 0.44rem;
            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }
    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }
        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }
            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }
            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;
              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }
            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .code {
        width: 1.94rem;
        height: 1.94rem;
      }
      .text {
        height: 1.72rem;
      }
    }
  }
}
</style>
